import * as xmljs from 'xml-js';

export default function(xliff: string): xmljs.ElementCompact  {
    return xmljs.xml2js(xliff, { compact: true});
}

